import { render, staticRenderFns } from "./RegistrationPersonal.vue?vue&type=template&id=f24428fc&"
import script from "./RegistrationPersonal.vue?vue&type=script&lang=js&"
export * from "./RegistrationPersonal.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationPersonal.vue?vue&type=style&index=0&id=f24428fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports